module.exports = __webpack_public_path__ + "c4680cd99e39aa056f2722fea72cc97e.jpg";